(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bundle-accordions"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const openBtn = event.target.closest('[data-bundle-qa-modal-open]');
    if (openBtn) {
      const root = openBtn.closest('.bundle-accordions');
      const dialog = root && root.querySelector('[data-bundle-qa-modal]');
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
      return;
    }

    const closeBtn = event.target.closest('[data-bundle-qa-modal-close]');
    if (closeBtn) {
      const dialog = closeBtn.closest('dialog');
      if (dialog) dialog.close();
    }
  });

  document.addEventListener('click', (event) => {
    if (event.target.matches('dialog[data-bundle-qa-modal]')) {
      event.target.close();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
